import CustomerProfileSimpleView from './CustomerProfileSimpleView'

export default CustomerProfileSimpleView
